import {APP_INITIALIZER, inject, Provider} from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {DeactivateBookingSubscriber} from '../../application/subscribers/deactivate-booking.subscriber';
import {UnlockBookingSubscriber} from "../../application/subscribers/unlock-booking.subscriber";
import {AccountEntriesAppliedSubscriber} from '../../application/subscribers/account-entries-applied.subscriber';
import {ValidateLockSubscriber} from "../../application/subscribers/validate-lock.subscriber";
import {BookingRepository} from "../../domain/repositories/booking.repository";
import {BOOKING_SESSION} from '../../domain/tokens/booking-session.token';
import {
  BOOKING_LISTENER,
  BOOKING_REPOSITORY,
  BOOKING_SCROLL_POSITION_REPOSITORY,
  BOOKING_SPACE_REPOSITORY,
  DOMAIN_SUBSCRIBERS
} from '../../domain/tokens/booking.tokens';
import {BookingRepositoryAdapter} from "../adapters/booking-repository.adapter";
import {BookingSessionAdapter} from '../adapters/booking-session.adapter';
import {BookingSpaceRepositoryAdapter} from "../adapters/space-repository.adapter";
import {BookingSocketListenerService} from '../listeners/booking-socket.listener';
import {BookingMockService} from "../services/booking-mock.service";
import {BookingScrollPositionIndexedDBAdapter} from "../adapters/booking-scroll-position.adapter";

export const BOOKING_PROVIDERS: Provider[] = [
  {
    provide: BOOKING_REPOSITORY,
    useFactory: (): BookingRepository => {
      return environment.mocksData.bookings
        ? inject(BookingMockService)
        : inject(BookingRepositoryAdapter);
    }
  },
  {
    provide: BOOKING_SPACE_REPOSITORY,
    useClass: BookingSpaceRepositoryAdapter
  },
  {
    provide: BOOKING_SCROLL_POSITION_REPOSITORY,
    useClass: BookingScrollPositionIndexedDBAdapter
  },
  {
    provide: BOOKING_SESSION,
    useClass: BookingSessionAdapter
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: UnlockBookingSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: AccountEntriesAppliedSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: DeactivateBookingSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: ValidateLockSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: AccountEntriesAppliedSubscriber,
    multi: true
  },
  {
    provide: BOOKING_LISTENER,
    useClass: BookingSocketListenerService,
  },
  {
    provide: APP_INITIALIZER,
    deps: [DOMAIN_SUBSCRIBERS, BOOKING_LISTENER],
    useFactory: () => () => {
    },
    multi: true,
  },
];
